<template>
  <div class="col-xl-3 col-lg-12 theiaStickySidebar">
    <!-- Settings Sidebar -->
    <div class="card">
      <div class="card-body">
        <div class="settings-sidebar">
          <h4 class="fw-semibold mb-3">Organization</h4>
          <div class="list-group list-group-flush settings-sidebar">
            <router-link to="/leads-organization/initial-info" class="fw-medium">Initial Info</router-link>
            <router-link to="/leads-organization/concern-person-info" class="fw-medium">Concern Person Info</router-link>
   
          </div>
        </div>
      </div>
    </div>
    <!-- /Settings Sidebar -->
  </div>
</template>
